import React, { Component } from 'react';
import {
    Button, ModalHeader, ModalBody, ModalFooter, Col,
    Row, Card, CardBody
} from 'reactstrap';
import './style.scss';
import { Link } from 'react-router-dom';
// import ModalComponent from '../../ReusableComponents/ModalComponent/index';
import {
    setRiskGrades, setScorecardId, getScorecardDetails,
    setFinancialData,
    setNonFinancialData,
    setValidationFlag,
    setRequestBody,
    setCreateRequestBody
} from './action';
import { connect } from 'react-redux';
//import './style.css';
import AuthService from '../../../components/Services/AuthService';
import RiskGrades from './RiskGrades';
import MyAutosuggest from '../../../components/ReusableComponents/AutoSuggest/index';
import {
    FinancialChangeFunction,
    validateRiskGrades,
    validateRisk,
    riskFactorBody,
    editFinancialRiskFactors,
    editNonFinancialRiskFactors,
    deleteRiskFactor,
    propsChangeFunction,
    validateScorecardForm,
    updateFinancialData,
    checkDuplicateData
} from './helpers';
import { getCounterpartyType } from '../../../Analyst/Cases/Create/actions'
import ScorecardForm from './ScorecardForm';
import withAuth from '../../../components/Services/WithAuth';
import Modal from '../../../components/UI/Modal/Modal';
class CreateScorecardComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            body: null,
            nonFinancialSearch: [],
            overriddenSearch: [],
            saveSuccess: false,
            financialSearch: [],
            financialList: null,
            nonFinancialList: null,
            riskGrades: null,
            scorecardName: '',
            corporateName: '',
            counterPartyType: '',
            saveDataBody: [],
            validationFlag: false,
            errormessage: '',
            scorecardId: null,
            scoreDetails: '',
            validateScorecard: false,
            validationMessage: null,
            value: '',
            scorecardBasicDetails: {
                scorecardName: '',
                corporateName: '',
                counterPartyType: ''
            }
        }
        this.Auth = new AuthService();
    }
    componentDidMount() {
        this.props.fetchCounterPartyType();
    }
    handleView = (id) => {
        this.props.history.push(`./edit/${id}`);
    }
    handleLogout = () => {
        this.Auth.logout();
        this.props.navigationCallback(false);
    }
    close = () => {
        this.setState({ showModal: !this.state.showModal })
    }
    componentDidUpdate(prevProps) {
        const { createScorecardSuccess, createScorecardError, editScorecardSuccess, editScorecardError, counterPartyTypeDropdown } = this.props
        if (counterPartyTypeDropdown !== prevProps.counterPartyTypeDropdown) {
            const scoreId = this.props.match.params.scorecardid;
            if (scoreId) {
                this.setState({ scorecardId: scoreId })
                this.props.setScorecardId(scoreId);
            } else {
                this.props.getScorecardDetails(null);
            }
        }
        if (editScorecardSuccess !== prevProps.editScorecardSuccess) {
            this.setState({
                showModal: !this.state.showModal,
                body: <div>
                    <ModalHeader>Success</ModalHeader>
                    <ModalBody>
                        <p>{editScorecardSuccess.data.templateName} Scorecard Edited Successfully</p>
                    </ModalBody>
                    <ModalFooter>
                        {/* <Button color="info" onClick={() => this.handleView(createScorecardSuccess.data.id)}>View</Button> */}
                        <Button color="secondary" onClick={this.close}>Close</Button>
                    </ModalFooter>
                </div>
            })
        } else if (editScorecardError !== prevProps.editScorecardError) {
            if (createScorecardError.response.status === 401) {
                this.setState({
                    showModal: !this.state.showModal,
                    body: <div>
                        <ModalHeader>Error</ModalHeader>
                        <ModalBody>
                            <p><i className="fa fa-exclamation-circle red"></i>&nbsp;&nbsp;Authorization Error</p>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="info" onClick={this.handleLogout}> <Link className="py-3 d-inline-block" onClick={this.handleLogout} to="/">Logout</Link></Button>
                        </ModalFooter>
                    </div>
                })
            } else {
                this.setState({
                    showModal: !this.state.showModal,
                    body: <div>
                        <ModalHeader>Error</ModalHeader>
                        <ModalBody>
                            <p><i className="fa fa-exclamation-circle red"></i>&nbsp;&nbsp; {editScorecardError.response.data}</p>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={this.close}>Close</Button>
                        </ModalFooter>
                    </div>
                })
            }
        }
        if (createScorecardSuccess !== prevProps.createScorecardSuccess) {
            this.setState({
                showModal: !this.state.showModal,
                body: <div>
                    <ModalHeader>Success</ModalHeader>
                    <ModalBody>
                        <p>{createScorecardSuccess.data.value} Scorecard Created Successfully</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="info" onClick={() => this.handleView(createScorecardSuccess.data.id)}>View</Button>
                        <Button color="secondary" onClick={this.close}>Close</Button>
                    </ModalFooter>
                </div>
            })
        } else if (createScorecardError !== prevProps.createScorecardError) {
            if (createScorecardError.response.status === 401) {
                this.setState({
                    showModal: !this.state.showModal,
                    body: <div>
                        <ModalHeader>Error</ModalHeader>
                        <ModalBody>
                            <p><i className="fa fa-exclamation-circle red"></i>&nbsp;&nbsp;Authorization Error</p>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="info" onClick={this.handleLogout}> <Link className="py-3 d-inline-block" onClick={this.handleLogout} to="/">Logout</Link></Button>
                        </ModalFooter>
                    </div>
                })
            } else {
                this.setState({
                    showModal: !this.state.showModal,
                    body: <div>
                        <ModalHeader>Error</ModalHeader>
                        <ModalBody>
                            <p><i className="fa fa-exclamation-circle red"></i>&nbsp;&nbsp; {createScorecardError.response.data}</p>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={this.close}>Close</Button>
                        </ModalFooter>
                    </div>
                })
            }
        }
        if (this.props.scoreDetails !== prevProps.scoreDetails) {
            if (this.state.scorecardId) {
                this.editRiskFactors();
            } else {
                this.props.setRiskGardes(null);
                this.props.setFinancialData([]);
                this.props.setNonFinancialData([]);
            }
        }
        const propFlag = propsChangeFunction(this.props.financialSearch, this.props.nonFinancialSearch, this.props.overriddenSearch, prevProps);
        if (propFlag) {

                this.onFinancialChange('qualitative');
                this.onFinancialChange('quantitative');
            
        }
        if (this.props.scorecardForm !== prevProps.scorecardForm) {
            if (this.props.scorecardForm.values) {
                this.setState({
                    scorecardName: this.props.scorecardForm.values.scorecardName,
                    corporateName: this.props.scorecardForm.values.corporateName,
                    counterPartyType: this.props.scorecardForm.values.counterPartyType,
                })
            }
        }
    }
    editRiskFactors = () => {
        this.setState({
            scorecardBasicDetails: {
                scorecardName: this.props.scoreDetails.templateName,
                corporateName: this.props.scoreDetails.corporateName,
                counterPartyType: this.props.scoreDetails.counterpartyType
            }
        })
        this.props.setRiskGardes(this.props.scoreDetails.riskGrades);
        this.props.setFinancialData(editFinancialRiskFactors(this.props.scoreDetails));
        this.props.setNonFinancialData(editNonFinancialRiskFactors(this.props.scoreDetails));

    }
    handleFinDeleteRisk = (event, id) => {
        this.props.setFinancialData(deleteRiskFactor(this.props.financialSearch, id))
    }
    handleNonFinDeleteRisk(event, id) {
        this.props.setNonFinancialData(deleteRiskFactor(this.props.nonFinancialSearch, id))
    }
    handleLogout = () => {
        this.Auth.logout();
        this.props.history.push('../../login');
    }
    onFinancialChange(searchType) {
        if (searchType === 'quantitative') {
            this.setState({
                financialList: this.props.financialSearch.map(p => {
                    const tempValue = p.weight;
                    return (
                        <tr key={p.id} >
                            <td key={p.id + 'td'}>
                                {p.value}
                            </td>
                            <td key={p.id + 'td1'}>
                                <input type="text" placeholder="weight" className="form-control" defaultValue={tempValue} name={p.value} onChange={(event) => this.handleFinancialChange(event, p.id)} required />
                            </td>
                            <td className="text-right">
                                <button type="button" id={p.id} className="btn btn-sm btn-link border-0 text-danger pr-0" title="Delete Financial Factor" onClick={(event) => this.handleFinDeleteRisk(event, p.id)}>
                                    Remove
                                </button>
                            </td>
                        </tr>
                    );
                })
            })
        } else if (searchType === 'qualitative') {
            this.setState({
                nonFinancialList: this.props.nonFinancialSearch.map(p => {
                    return (
                        <tr key={p.id} >
                            <td key={p.id + 'td'}>
                                {p.value}
                            </td>
                            <td key={p.id + 'td1'}>
                                <input type="text" className="form-control" defaultValue={p.weight} name={p.value} onChange={(event) => this.handleNonFinancialChange(event, p.id)} required />
                            </td>
                            <td className="text-right">
                                <button type="button" id={p.id} className="btn btn-sm btn-link border-0 text-danger" title="Delete Non-Financial Factor" onClick={(event) => this.handleNonFinDeleteRisk(event, p.id)}>
                                    Remove
                                </button>
                            </td>
                        </tr>
                    );
                })
            })
        }
    }
    handleNonFinancialChange = (event, id) => {
        this.props.setNonFinancialData(FinancialChangeFunction(event, id, this.props.nonFinancialSearch));
    }
    handleFinancialChange(event, id) {
        this.props.setFinancialData(FinancialChangeFunction(event, id, this.props.financialSearch));
    }
    searchCallback = (searchResult, searchType) => {
        if (searchType === 'quantitative') {
            if (this.props.financialSearch.length === 0) {
                const financialSearchUpdatedData = updateFinancialData(this.props.financialSearch, searchResult);
                this.props.setFinancialData(financialSearchUpdatedData);
            } else {
                const duplicateFinancialSearchData = checkDuplicateData(this.props.financialSearch, searchResult)
                this.props.setFinancialData(duplicateFinancialSearchData);
            }

        } else if (searchType === 'qualitative') {
            if (this.props.nonFinancialSearch.length === 0) {
                const financialSearchUpdatedData = updateFinancialData(this.props.nonFinancialSearch, searchResult);
                this.props.setNonFinancialData(financialSearchUpdatedData);
            } else {
                const duplicateNonFinancialSearchData = checkDuplicateData(this.props.nonFinancialSearch, searchResult)
                this.props.setNonFinancialData(duplicateNonFinancialSearchData);
            }
        }
    }
    handleSave = () => {
        let requestBody;
        if (validateRiskGrades(this.props.riskGrades) && validateScorecardForm(this.props.scorecardForm.values) && validateRisk(this.props.financialSearch, this.props.nonFinancialSearch)) {
            requestBody = {
                id: this.props.scorecardId,
                templateName: this.state.scorecardName,
                corporateName: this.state.corporateName,
                counterpartyType: this.state.counterPartyType,
                riskGrades: this.props.riskGrades,
                riskfactors: riskFactorBody(this.props.financialSearch, this.props.nonFinancialSearch),
                corporateId: "qwerty12345b"
            }
            if (this.state.scorecardId) {
                this.props.setRequestBody(requestBody);
            } else {
                this.props.createRequestBody(requestBody);
            }

        } else {
            this.setState({
                errormessage: `*All the fields are required`
            })
        }

    }
    handleCancel = (event) => {
        event.preventDefault();
        this.props.history.push('/scorecard/search');
    }
    redirectToView = () => {
        this.setState({
            saveSuccess: !this.state.saveSuccess
        }, () => {
            this.props.history.push('/scorecard/view/' + this.state.scorecardId);
        });
    }
    EditTitleLable = (props) => {
        return "Edit Scorecard";
    }
    CreateTitleLabel = (props) => {
        return "Create Scorecard";
    }
    handleClose = () => {
        this.props.history.push('/scorecard/search');
    }

    onChange = (event, { newValue }) => {
        this.setState({
            value: newValue
        });
    };
    render() {
        const { value } = this.state
        const inputProps = {
            placeholder: "Start typing risk factor name...",
            onChange: this.onChange,
            disabled: false,
            className: "form-control",
            value: value
        }

        let titleLabel;

        if (this.props.scorecardId) {
            titleLabel = <this.EditTitleLable></this.EditTitleLable>;
        }
        else {
            titleLabel = <this.CreateTitleLabel></this.CreateTitleLabel>;
        }
        return (
            <Col className="scorecard-create">
                <Row>
                    <Col>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h4 className="mb-0">
                                {titleLabel}
                            </h4>
                        </div>
                        <Card>
                            <CardBody className="pb-100">
                                <ScorecardForm corporateDetailCallBack={this.corporateDetailCallBack} initialValues={this.state.scorecardBasicDetails} scorecardEditData={this.state.scorecardBasicDetails} />
                                <form autoComplete="on" className="w-70">
                                    <div className="mb-4">
                                        <h6>Financial Factors&nbsp;<span className="text-danger">*</span></h6>
                                        <table className="table table-bordered border-bottom-0 mb-0">
                                            <thead className="header-blue">
                                                <tr>
                                                    <th>Factor</th>
                                                    <th>Weight</th>
                                                    <th className="text-right">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.financialList}
                                            </tbody>
                                        </table>
                                        <MyAutosuggest id="quantitative"
                                            placeholder="Search &amp; Add Financial Risk Factors"
                                            onChange={this.handleFinancialChange}
                                            financialData={this.state.financialSearch}
                                            searchCallback={this.searchCallback}
                                            inputProps={inputProps} />
                                    </div>
                                    <div className="mb-4">
                                        <h6>Non Financial Factors&nbsp;<span className="text-danger">*</span></h6>
                                        <table className="table table-bordered border-bottom-0 mb-0">
                                            <thead className="header-blue">
                                                <tr>
                                                    <th>Factor</th>
                                                    <th>Weight</th>
                                                    <th className="text-right">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.nonFinancialList}
                                            </tbody>
                                        </table>
                                        <MyAutosuggest id="qualitative"
                                            placeholder="Search &amp; Add Non-Financial Risk Factors"
                                            onChange={this.handleNonFinancialChange}
                                            financialData={this.state.nonFinancialSearch}
                                            searchCallback={this.searchCallback}
                                            inputProps={inputProps} />
                                    </div>


                                    <div>
                                        <h6>Risk Grades</h6>
                                        <RiskGrades riskCallBack={this.riskCallBack} riskGradeData={this.state.scoreDetails.riskGrades} />
                                    </div>
                                    <footer className="bg-light footer w-100 text-center">
                                        <Button color="primary" onClick={this.handleSave}>Save</Button>
                                    </footer>
                                </form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Modal show={this.state.showModal} modalClosed={this.close} >
                    {/* {/ <p>Show Modal Data</p > /} */}
                    {this.state.body}
                </Modal>
            </Col>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    scorecardId: state.createScorecard.id,
    riskGrades: state.riskGrades.riskGrades,
    scoreDetails: state.createScorecard.scoreDetails,
    financialSearch: state.createScorecard.financialSearch,
    nonFinancialSearch: state.createScorecard.nonFinancialSearch,
    overriddenSearch: state.createScorecard.overriddenSearch,
    // validationFlag: state.createScorecard.validationFlag,
    counterPartyTypeDropdown: state.createCase.dropdownData,
    scorecardForm: state.form.scoreform,
    createScorecardSuccess: state.createScorecard.createScorecardSuccess,
    createScorecardError: state.createScorecard.createScorecardError,
    editScorecardSuccess: state.createScorecard.editScorecardSuccess,
    editScorecardError: state.createScorecard.editScorecardError
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    setScorecardId: (id) => dispatch(setScorecardId(id)),
    getScorecardDetails: (id) => dispatch(getScorecardDetails(id)),
    setRiskGardes: (riskData) => dispatch(setRiskGrades(riskData)),
    setFinancialData: (financialData) => dispatch(setFinancialData(financialData)),
    setNonFinancialData: (nonFinancialData) => dispatch(setNonFinancialData(nonFinancialData)),
    // setOverriddenData: (overriddenData) => dispatch(setOverriddenData(overriddenData)),
    setValidationFlag: (validationFlag) => dispatch(setValidationFlag(validationFlag)),
    setRequestBody: (requestBody) => dispatch(setRequestBody(requestBody)),
    createRequestBody: (requestBody) => dispatch(setCreateRequestBody(requestBody)),
    fetchCounterPartyType: () => dispatch(getCounterpartyType()),
});
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withAuth(CreateScorecardComponent));
